import { render, staticRenderFns } from "./QCategoriesDataTable.vue?vue&type=template&id=2cda5d74&scoped=true&"
import script from "./QCategoriesDataTable.vue?vue&type=script&lang=js&"
export * from "./QCategoriesDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QCategoriesDataTable.vue?vue&type=style&index=0&id=2cda5d74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cda5d74",
  null
  
)

export default component.exports